import {Vue, Component, Prop} from "vue-property-decorator";
import { sanitize } from "~/lib/helpers/dom";

@Component
class HTMLSanitizer extends Vue {

  @Prop({type: String, required:true}) protected html:string;

  get formattedHTML(){
    return sanitize(this.html);
  }

  render() {
    if( ! this.html) return <div />;
    return <div domPropsInnerHTML={this.formattedHTML} />;
  }
}

export {HTMLSanitizer};

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7fce5c33/html-sanitizer.tsx" });